import { useState } from 'react';
import {
  Container, TextField, Button, Typography, Paper, Box
} from '@mui/material';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { setToken } from '../utils/auth';
import logo from '../assets/logo.png';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [usernameError, setUsernameError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async () => {
  setUsernameError(false);
  setPasswordError(false);

  let hasError = false;
  if (!username.trim()) {
    setUsernameError(true);
    hasError = true;
  }
  if (!password.trim()) {
    setPasswordError(true);
    hasError = true;
  }
  if (hasError) return;

  try {
    const res = await axios.post(`${process.env.REACT_APP_BASE_URL}/auth/login`, {
      username,
      password,
    });

    // ✅ Store token
    setToken(res.data.token);

    // ✅ Store user info in localStorage
    localStorage.setItem('user', JSON.stringify(res.data.user));
    console.log(localStorage.getItem('user'));

    // ✅ Navigate to dashboard
    navigate('/dashboard');
  } catch (err: any) {
    const message = err.response?.data?.message || 'Login failed. Please try again.';
    Swal.fire({
      icon: 'error',
      title: 'Login Error',
      text: message,
    });
  }
};


  return (
    <Container maxWidth="sm">
      <Paper
        elevation={3}
        sx={{
          padding: 4,
          marginTop: 10,
          textAlign: 'center',
          borderTop: '6px solid #6226A7',
        }}
      >
        <Box mb={2}>
          <img src={logo} alt="QuillStack Logo" width={100} />
        </Box>
        <Typography variant="h5" gutterBottom>
          QuillStack Admin Login
        </Typography>
        <Box display="flex" flexDirection="column" gap={2} mt={3}>
          <TextField
  label="Username"
  value={username}
  onChange={(e) => {
    setUsername(e.target.value);
    if (e.target.value.trim()) {
      setUsernameError(false); // Clear red border when typing valid input
    }
  }}
  fullWidth
  error={usernameError}
  helperText={usernameError ? 'Username is required' : ''}
/>

<TextField
  label="Password"
  type="password"
  value={password}
  onChange={(e) => {
    setPassword(e.target.value);
    if (e.target.value.trim()) {
      setPasswordError(false); // Clear red border when typing valid input
    }
  }}
  fullWidth
  error={passwordError}
  helperText={passwordError ? 'Password is required' : ''}
/>

          <Button
            variant="contained"
            onClick={handleLogin}
            sx={{
              background: 'linear-gradient(to right, #6226A7, #F6A938)',
              color: '#fff',
              fontWeight: 600,
              '&:hover': {
                background: 'linear-gradient(to right, #4e1f84, #db8b21)',
              },
            }}
          >
            Login
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default Login;
